define('rebrush/components/product/view/tracking',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'cartware/components/Registry'
], function (
    $,
    _,
    Component,
    BEM,
    Registry
) {
    return Component.create({
        spConfig: null,
        viewItemEvent: 'view_item',
        dataLayer: null,

        $init: function () {
            this.initComponent();
        },

        initComponent: function () {
            Registry().retrieve('product.view.configurable.spConfig', _.bind(function (spConfig) {
                this.spConfig = spConfig;
                this.bindEvents();
                this.trackItemView();
            }, this));
        },

        bindEvents: function () {
            $(document).on('product/changeSimple', $.proxy(this._onSimpleChange, this));
        },

        trackItemView: function () {
            var dataLayer = window.dataLayer || [];
            if (typeof window.dataLayer !== 'undefined' && typeof window.dataLayer.ecommerce !== 'undefined') {
                dataLayer.push({
                    'ecommerce': undefined
                });
            }
            var ecommerce = this.getItemTrackingJson();
            dataLayer.push({'event': this.viewItemEvent, ecommerce});

            if (typeof window.dataLayer === 'undefined' || !window.dataLayer) {
                window.dataLayer = dataLayer;
            }
        },

        getItemTrackingJson: function () {
            var ecommerce = {},
                currentSimple = this.spConfig.__currentSimple,
                discount = 0.00,
                originalPrice = 0.00,
                finalPrice = 0.00;

            const item = {
                'item_id': this.spConfig.config.id_to_sku[currentSimple.id],
                'item_name': currentSimple.product_name,
                'index': 0
            };

            if (currentSimple.attributes) {
                var attributes = Object.values(currentSimple.attributes);

                // sort by code desc
                attributes.sort((a, b) => {
                    const nameA = a.code.toUpperCase();
                    const nameB = b.code.toUpperCase();
                    return (nameA > nameB) ? -1 : (nameA < nameB) ? 1 : 0;
                });

                item.item_variant = attributes.map((attribute) => attribute.text_default).join(' / ').toLowerCase();
            }

            if (Product.Config.prototype.hasOwnProperty('_configurable')) {
                const configurable = Product.Config.prototype._configurable;
                if (configurable.gtm_categories) {
                    Object.assign(item, configurable.gtm_categories);
                }
            }

            if (optionsPrice) {
                if (optionsPrice.priceInclTax) {
                    finalPrice = optionsPrice.priceInclTax;
                }
                if (optionsPrice.productOldPrice) {
                    originalPrice = optionsPrice.productOldPrice;
                }
                if (optionsPrice.optionPrices.config.price) {
                    finalPrice += optionsPrice.optionPrices.config.price;
                    originalPrice += optionsPrice.optionPrices.config.price;
                }
                if (optionsPrice.productOldPrice && optionsPrice.productPrice && (optionsPrice.productOldPrice !== optionsPrice.productPrice)) {
                    discount = optionsPrice.productOldPrice - optionsPrice.productPrice;
                }
            }

            item.price = parseFloat(Number(originalPrice.toFixed(2)));
            item.discount = parseFloat(Number(discount.toFixed(2)));

            ecommerce.items = [item];
            ecommerce.currency = gigaset.currency.code;
            ecommerce.value = parseFloat(Number(finalPrice.toFixed(2)));

            return ecommerce;
        },

        _onSimpleChange: function () {
            if (!this.spConfig) {
                this.spConfig = _.get(window, 'spConfig');
            }
            this.trackItemView();
        },
    });
});

